import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage';

const Layout = () => import('XY/views/Layout.vue');
const Login = () => import('XY/views/Login/Login.vue');
const ChatAnonymity = () => import('XY/views/ChatAnonymity/ChatAnonymity.vue');
const Home = () => import('XY/views/Home/Home.vue');
const DownLoadCenterAndAFK = () => import('XY/views/DownloadCenter/DownLoadCenterAndAFK.vue');
const Timeout = () => import('XY/views/ErrorHandle/Timeout.vue');
const Offline = () => import('XY/views/ErrorHandle/Offline.vue');
const ErrorMsg = () => import('XY/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('XY/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('XY/views/Register/Register.LinkFailure.vue');
const Register = () => import('XY/views/Register/Register.vue');
const Bet = () => import('XY/views/Bet/Bet.vue');
const ComboBet = () => import('XY/views/ComboBet/ComboBet.vue');
const MultiBet = () => import('XY/views/MultiBet/MultiBet.vue');

const WeChatRegister = () => import('BASE/components/register/register.wechat.component.js');
const DrawHistory = () => import('XY/views/DrawHistory/DrawHistory.vue');
const AccountInfo = () => import('XY/views/AccountCenter/AccountInfo.vue');
const ProportionalDividend = () => import('XY/views/ProportionalDividend/ProportionalDividend.vue');
const Player = () => import('XY/views/Player/Player.vue');
const BonusManagement = () => import('XY/views/Bonus/BonusManagement.vue');
const MyContract = () => import('XY/views/Dividend/MyContract.vue');
const MyContractExternalGame = () => import('XY/views/DividendExternalGame/MyContract.vue');
const DividendManagement = () => import('XY/views/Dividend/DividendManagement.vue');
const DividendExternalGameManagement = () => import('XY/views/DividendExternalGame/DividendManagement.vue');
const CreatePlayer = () => import('XY/views/Player/Player.Create.vue');
const RegisterLink = () => import('XY/views/RegisterLink/RegisterLink.vue');
const TradeAgreement = () => import('XY/views/TradeAgreement/TradeAgreement.vue');
const TradeAgreementCurrency = () => import('XY/views/TradeAgreement/TradeAgreement.Currency.vue');
const ExternalGameTrans = () => import('XY/views/ExternalGameTrans/ExternalGameTrans.vue');
const ExternalGameLobby = () => import('XY/views/ExternalGame/ExternalGameLobby.vue');
const WithdrawRequest = () => import('XY/views/WithdrawRequest/WithdrawRequest.vue');
const WithdrawRecord = () => import('XY/views/WithdrawRecord/WithdrawRecord.vue');
const ExternalGameTransRecord = () => import('XY/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const BetRecord = () => import('XY/views/BetRecord/BetRecord.vue');
const ScheduleRecord = () => import('XY/views/ScheduleRecord/ScheduleRecord.vue');
const CashFlowRecord = () => import('XY/views/CashFlowRecord/CashFlowRecord.vue');
const ActiveAccount = () => import('XY/views/ActiveAccount/ActiveAccount.vue');
const AccountSecurity = () => import('XY/views/AccountCenter/AccountSecurity.vue');
const AccountPassword = () => import('XY/views/AccountCenter/AccountPassword.vue');
const DrawLobby = () => import('XY/views/DrawLobby/DrawLobby.vue');
const ProfitReport = () => import('XY/views/ProfitReport/ProfitReport.Main.vue');
const Deposit = () => import('XY/views/Deposit/Deposit.vue');
const DepositQrcode = () => import('XY/views/Deposit/DepositQrcode.vue');
const DepositRecord = () => import('XY/views/DepositRecord/DepositRecord.vue');
const AwardDetail = () => import('XY/views/AwardDetail/AwardDetail.vue');
const Activity = () => import('XY/views/Activity/Activity.vue');
const OneDollarActivity = () => import('XY/views/Activity/OneDollarActivity.vue');
const DailyInterestActivity = () => import('XY/views/Activity/DailyInterest.vue');
const Coupon = () => import('XY/views/Coupon/Coupon.vue');
const FirstDepositByCategoryActivity = () => import('XY/views/Activity/FirstDepositByCategoryActivity.vue');
const DepositConsumeKENO2Activity = () => import('XY/views/Activity/DepositConsumeKENO2Activity.vue');
const DailySigninRedPackActivity = () => import('XY/views/Activity/DailySigninRedPackActivity.vue');
const RouletteActivity = () => import('XY/views/Activity/RouletteActivity.vue');
const NewbieQuestActivity = () => import('XY/views/Activity/NewbieQuestActivity.vue');
const RedPacketSolitaire = () => import('XY/views/Activity/RedPacketSolitaire.vue');
const Lucky7SlotActivity = () => import('XY/views/Activity/Lucky7SlotActivity.vue');
const RedPackRainActivity = () => import('XY/views/Activity/RedPackRainActivity.vue');
const BonusWallet = () => import('XY/views/AccountCenter/BonusWallet.vue');
const BlockChainHash = () => import('XY/views/BlockChainHash/BlockChainHash.vue');
const IFrame = () => import('XY/views/IFrame.vue');
const Announcement = () => import('XY/views/Announcement/Announcement.vue');
const TelegramLoginWidget = () => import('XY/views/TelegramLoginWidget.vue');
const ShareHolderBonusManagement = () => import('XY/views/ShareHolderBonus/ShareHolderBonusManagement.vue');
const LionKingContest = () => import('XY/views/Activity/LionKingContest.vue');
const CouponList = () => import('XY/views/Coupon/CouponList.vue');

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/ChatAnonymity', name: 'ChatAnonymity', component: ChatAnonymity, meta: { ignoreAuth: true } },
        { path: '/Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', component: LinkFailure, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        { path: '/Register', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        {
            path: '/WeChatRegister/:code',
            name: 'WeChatRegister',
            component: WeChatRegister,
            meta: { ignoreAuth: true },
        },
        { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode },
        {
            path: '/TelegramLoginWidget',
            name: 'TelegramLoginWidget',
            component: TelegramLoginWidget,
            meta: { ignoreAuth: true },
        },
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        //以下是登入後須套用header、footer、chat的頁面
        {
            path: '/',
            component: Layout,
            children: [
                { path: '/', name: 'Home', component: Home },
                { path: '/Announcement', name: 'Announcement', component: Announcement },
                { path: '/Bet/:id', name: 'Bet', component: Bet },
                {
                    path: '/MultiBet/:type',
                    name: 'MultiBet',
                    component: MultiBet,
                },
                { path: '/ComboBet', name: 'ComboBet', component: ComboBet },
                { path: '/DownLoadCenterAndAFK', name: 'DownLoadCenterAndAFK', component: DownLoadCenterAndAFK },
                { path: '/AccountInfo', name: 'AccountInfo', component: AccountInfo },
                { path: '/Player', component: Player, meta: { isAgentAllow: true } },
                { path: '/ProportionalDividend', component: ProportionalDividend },
                {
                    path: '/ShareHolderBonusManagementLottery',
                    name: 'ShareHolderBonusManagementLottery',
                    component: ShareHolderBonusManagement,
                    props: { type: 'LOTTERY' },
                    meta: { isAgentAllow: true },
                },
                {
                    path: '/ShareHolderBonusManagementExternal',
                    name: 'ShareHolderBonusManagementExternal',
                    component: ShareHolderBonusManagement,
                    props: { type: 'EXTERNALGAME' },
                    meta: { isAgentAllow: true },
                },
                {
                    path: '/BonusManagement',
                    name: 'BonusManagement',
                    component: BonusManagement,
                    meta: { isAgentAllow: true },
                },
                { path: '/MyContract', component: MyContract },
                { path: '/DividendManagement', component: DividendManagement, meta: { isAgentAllow: true } },
                { path: '/CreatePlayer', component: CreatePlayer, meta: { isAgentAllow: true } },
                { path: '/RegisterLink', component: RegisterLink, meta: { isAgentAllow: true } },
                { path: '/AwardDetail', name: 'AwardDetail', component: AwardDetail },
                { path: '/TradeAgreement', component: TradeAgreement },
                { path: '/TradeAgreementCurrency', component: TradeAgreementCurrency },
                { path: '/ExternalGameTrans', name: 'ExternalGameTrans', component: ExternalGameTrans },
                { path: '/ExternalGameLobby/:category?', name: 'ExternalGameLobby', component: ExternalGameLobby },
                { path: '/WithdrawRequest', name: 'WithdrawRequest', component: WithdrawRequest },
                { path: '/WithdrawRecord', name: 'WithdrawRecord', component: WithdrawRecord },

                { path: '/AccountSecurity', name: 'AccountSecurity', component: AccountSecurity },
                { path: '/AccountPassword', name: 'AccountPassword', component: AccountPassword },
                { path: '/BonusWallet', name: 'BonusWallet', component: BonusWallet },
                {
                    path: '/ExternalGameTransRecord',
                    name: 'ExternalGameTransRecord',
                    component: ExternalGameTransRecord,
                },
                { path: '/BetRecord', name: 'BetRecord', component: BetRecord },
                { path: '/ScheduleRecord', name: 'ScheduleRecord', component: ScheduleRecord },
                { path: '/CashFlowRecord', name: 'CashFlowRecord', component: CashFlowRecord },
                {
                    path: '/ActiveAccount',
                    name: 'ActiveAccount',
                    component: ActiveAccount,
                    meta: { isAgentAllow: true },
                },
                { path: '/DrawHistory/:id', name: 'DrawHistory', component: DrawHistory },
                { path: '/DrawLobby', name: 'DrawLobby', component: DrawLobby },
                { path: '/ProfitReport', name: 'ProfitReport', component: ProfitReport },
                { path: '/Deposit', name: 'Deposit', component: Deposit },
                { path: '/DepositRecord', name: 'DepositRecord', component: DepositRecord },
                { path: '/Activity', name: 'Activity', component: Activity },
                { path: '/OneDollarActivity', name: 'OneDollarActivity', component: OneDollarActivity },
                { path: '/DailyInterestActivity', name: 'DailyInterestActivity', component: DailyInterestActivity },
                { path: '/Coupon', name: 'Coupon', component: Coupon },
                {
                    path: '/FirstDepositByCategoryActivity',
                    name: 'FirstDepositByCategoryActivity',
                    component: FirstDepositByCategoryActivity,
                },
                {
                    path: '/DepositConsumeKENO2Activity/:id',
                    name: 'DepositConsumeKENO2Activity',
                    component: DepositConsumeKENO2Activity,
                },
                {
                    path: '/DailySigninRedPackActivity',
                    name: 'DailySigninRedPackActivity',
                    component: DailySigninRedPackActivity,
                },
                { path: '/RouletteActivity', name: 'RouletteActivity', component: RouletteActivity },
                { path: '/NewbieQuestActivity', name: 'NewbieQuestActivity', component: NewbieQuestActivity },
                { path: '/RedPacketSolitaire', name: 'RedPacketSolitaire', component: RedPacketSolitaire },
                { path: '/Lucky7SlotActivity', name: 'Lucky7SlotActivity', component: Lucky7SlotActivity },
                { path: '/RedPackRainActivity', name: 'RedPackRainActivity', component: RedPackRainActivity },
                { path: '/LionKingContest', name: 'LionKingContest', component: LionKingContest },
                { path: '/BlockChainHash', name: 'BlockChainHash', component: BlockChainHash },
                { path: '/IFrame', name: 'IFrame', component: IFrame },
                { path: '/CouponList', name: 'CouponList', component: CouponList },
            ],
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == 'Login') {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some((record) => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some((record) => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }

        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        } else if (to.name === 'Home' && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/Login');
        } else {
            next('/Timeout'); // 認證已過期
        }
    }
});

// 投注一般、旗艦版導向
router.afterEach((to) => {
    if (to.meta.betClientTemplate) {
        storage.local.set(storage.keys.BET_CLIENT_TEMPLATE, to.meta.betClientTemplate);
    }
});

export default router;
